import { render, staticRenderFns } from "./UpdateStatusModal.vue?vue&type=template&id=4f6274ea&scoped=true"
import script from "./UpdateStatusModal.vue?vue&type=script&lang=js"
export * from "./UpdateStatusModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateStatusModal.vue?vue&type=style&index=0&id=4f6274ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6274ea",
  null
  
)

export default component.exports